import React from "react";

/** Editorial content shell with eyebrow, headline, meta, and long-form body. */
export default function LegalShell({ eyebrow, title, updated, children }) {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-10 py-16">
      <div className="label-eyebrow text-brand-terracotta">{eyebrow}</div>
      <h1 className="font-serif text-5xl md:text-7xl tracking-tighter mt-3 text-brand-ink leading-none">{title}</h1>
      {updated && <div className="mt-4 text-xs uppercase tracking-widest text-brand-muted">Last updated · {updated}</div>}
      <div className="mt-12 prose-wrmm">
        {children}
      </div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="mt-12 first:mt-0">
      <h2 className="font-serif text-2xl md:text-3xl text-brand-ink tracking-tight">{title}</h2>
      <div className="mt-4 text-brand-ink/85 leading-relaxed space-y-4 font-sans">{children}</div>
    </section>
  );
}
